import { Link } from "react-router-dom";

/**
 * Chain chooser — the CTA target. Two options side by side; picking one routes
 * to that chain's own connect gate (Sui: dapp-kit ConnectButton → Slush/Martian;
 * Solana: ConnectGate → Phantom/Solflare), which signs the operator in and lands
 * on the matching dashboard. Sui is the primary (live track); Solana is secondary.
 */
export function ChooseChainPage() {
  return (
    <div className="cc">
      <div className="cc__inner">
        <div className="cc__kick">altheia · control plane</div>
        <h1 className="cc__title">Choose a chain to continue</h1>
        <p className="cc__sub">Your wallet is your operator identity. You sign a one-time challenge, no transaction, no spend.</p>

        <div className="cc__grid">
          <Link to="/sui" className="cc__card cc__card--primary">
            <span className="cc__badge">live track</span>
            <span className="cc__chain">Sui</span>
            <span className="cc__desc">Policy enforced by a Move object. Connect with Slush, Martian, or Suiet.</span>
            <span className="cc__go">Connect Sui wallet <span className="cc__arrow">→</span></span>
          </Link>

          <Link to="/dashboard" className="cc__card">
            <span className="cc__chain">Solana</span>
            <span className="cc__desc">The same control plane, on Swig session keys. Connect with Phantom or Solflare.</span>
            <span className="cc__go">Connect Solana wallet <span className="cc__arrow">→</span></span>
          </Link>
        </div>

        <Link to="/" className="cc__back">← back to home</Link>
      </div>

      <style>{`
        .cc { min-height: 100dvh; display: flex; align-items: center; justify-content: center; background: var(--bg); padding: var(--s-6); }
        .cc__inner { width: 100%; max-width: 920px; text-align: center; }
        .cc__kick { font: var(--type-kicker); letter-spacing: var(--tracking-kicker); text-transform: uppercase; color: var(--accent); margin-bottom: var(--s-4); }
        .cc__title { font: var(--type-display-page); font-style: italic; color: var(--bone); margin: 0 0 var(--s-3); }
        .cc__sub { font: var(--type-body); color: var(--slate); max-width: 48ch; margin: 0 auto var(--s-7); line-height: 1.6; }
        .cc__grid { display: grid; grid-template-columns: 1fr 1fr; gap: var(--s-5); text-align: left; }
        .cc__card { position: relative; display: flex; flex-direction: column; gap: var(--s-3); padding: var(--s-6); border: 1px solid var(--line); border-radius: var(--r-md); background: var(--bg-elev); transition: border-color 180ms cubic-bezier(0.23,1,0.32,1), transform 180ms cubic-bezier(0.23,1,0.32,1), box-shadow 180ms ease; }
        .cc__card:hover { transform: translateY(-3px); border-color: var(--line-stamp); box-shadow: 0 20px 50px -24px color-mix(in srgb, var(--indigo) 45%, transparent); }
        .cc__card:active { transform: translateY(-1px) scale(0.995); }
        .cc__card--primary { border-color: color-mix(in srgb, var(--accent) 55%, var(--line)); background: linear-gradient(180deg, color-mix(in srgb, var(--accent) 7%, var(--bg-elev)), var(--bg-elev)); }
        .cc__card--primary:hover { border-color: var(--accent); box-shadow: 0 24px 56px -22px color-mix(in srgb, var(--accent) 38%, transparent); }
        .cc__badge { position: absolute; top: var(--s-4); right: var(--s-4); font: var(--type-mono-address); text-transform: uppercase; letter-spacing: 0.08em; color: var(--accent-deep); border: 1px solid color-mix(in srgb, var(--accent) 40%, var(--line)); border-radius: var(--r-sm); padding: 3px 8px; }
        .cc__chain { font: var(--type-display-section); font-style: italic; color: var(--bone); }
        .cc__desc { font: var(--type-body-small); color: var(--slate); line-height: 1.55; min-height: 3.2em; }
        .cc__go { display: inline-flex; align-items: center; gap: 8px; margin-top: var(--s-2); font: var(--type-label); letter-spacing: var(--tracking-label); text-transform: uppercase; color: var(--bone); }
        .cc__card--primary .cc__go { color: var(--accent-deep); }
        .cc__arrow { transition: transform 180ms cubic-bezier(0.23,1,0.32,1); }
        .cc__card:hover .cc__arrow { transform: translateX(4px); }
        .cc__back { display: inline-block; margin-top: var(--s-6); font: var(--type-mono-address); text-transform: uppercase; letter-spacing: 0.1em; color: var(--slate-2); }
        .cc__back:hover { color: var(--bone); }
        @media (max-width: 680px) { .cc__grid { grid-template-columns: 1fr; } }
        @media (prefers-reduced-motion: reduce) { .cc__card, .cc__arrow { transition: none; } .cc__card:hover { transform: none; } }
      `}</style>
    </div>
  );
}
